$ = require 'jquery'

module.exports = class LengthCheckingMixin

  checkLength: (e) ->
    text = $(e.target).val()
    maxLength = @maxLength || 16384
    isEmpty = text.length == 0 || /^\s*$/.test(text)
    isTooLong = !isEmpty && text.length > maxLength
    if @preventSubmit?
      @preventSubmit(isTooLong, isEmpty)
    else
      @_preventSubmit(isTooLong, isEmpty)

    return

  _preventSubmit: (isTooLong, isEmpty) ->
    @$('.js-too-long-warning').toggleClass('hide', !isTooLong)
    @$('.js-is-empty-warning').toggleClass('hide', !isEmpty)
    @$('input[type="submit"]').prop('disabled', isEmpty || isTooLong)



// WEBPACK FOOTER //
// ./app/scripts/views/internal/disable-submit-if-length-too-long.coffee